import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetLoading } from 'store/layout/action';

const RouteListener = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    console.log("Dispatching reset loading");
    dispatch(resetLoading());
  }, [location.pathname, dispatch]);

  return null;
};

export default RouteListener;

